// roller.js — KİM UÇUŞ EKİBİDİR, KİM HANGİ UÇAĞI UÇABİLİR · TEK KAYNAK (30 Eyl 2026)
//
// 🔑 Serkan (30 Eyl 2026): *"Bir kişinin rolü pilot ise crew görünmeli."* ·
//    *"Çözüm basit olmalı: bir personel pilot olarak tanımlanır, tip yetkisi
//    verilir, sonrasında pilotun yetkin olduğu tescille uçuşu mümkün olmalı."*
// 🔴 ÖNCESİ (ölçüldü): "kim uçuş ekibidir" web'de 15 yerde ayrı yazılıydı
//    (`UCAN_ROLLER`, 3× `PILOT_ROLES`, 11 satır içi liste); web FLT CREW'un iki
//    dalı rolü hiç süzmüyordu. Edge `manage-user`daki kopya başka çalışma
//    ortamında — nöbetçi testi onu bu listeyle eşit tutar. ARCHIVED FLTS kişi
//    listesini HİÇ süzmüyordu → admin (BTH) "All crew" süzgecinde ve Flight Crew
//    düzeltme kutusunda PF/PM/CRZ seçilebiliyordu. STATISTICS doğruydu.
// Şirket sınırı veritabanındadır (RLS `profiles_read`) — burada tekrar yazılmaz.
// Uçağın tipi TESCİLDEN okunur (AIRCRAFTS kaydı; orada tip zorunlu). Planın
//    `ac_type` alanı değil: o OFP metninden okunuyordu ve 30 Eyl ölçümünde 3 planda
//    GV yazılıydı (Cenevre'nin "GVA"sı), FPL'de GLF4.

export const UCUS_EKIBI_ROLLERI = ['pilot', 'admin_pilot'];

export const ucusEkibindenMi = p => !!p && UCUS_EKIBI_ROLLERI.includes(p.role);

// `crew_qualifications` satırları → { pilot_id: ['GLF4', …] }. 'EFB' bir uçak
// tipi değil, aynı tabloda tutulan EFB eğitim kaydıdır — tip yetkisi sayılmaz.
export function tipYetkiHaritasi(satirlar) {
  const h = {};
  (satirlar || []).forEach(q => {
    if (q.ac_type && q.ac_type !== 'EFB') (h[q.pilot_id] ||= []).push(q.ac_type);
  });
  return h;
}

// "TCREC" ile "TC-REC" aynı tescildir (parse-plan'daki `normReg` ile aynı kural).
const tescilAnahtari = v => String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
const tipAnahtari = v => String(v || '').trim().toUpperCase();

// Şirketin filosundaki tipler (tekil, sıralı) — tip yetkisi YALNIZ bunlardan seçilir.
// 🔑 Serkan (30 Eyl 2026): *"Drop menü olması gerekir, elle giremez, var olandan seçer."*
//    (FPL'de GLF4, uygulamada GULF4 gibi yazım farkı pilotu yetkisiz gösterirdi.)
export function filoTipleri(ucaklar) {
  return [...new Set((ucaklar || []).map(a => tipAnahtari(a.ac_type)).filter(Boolean))].sort();
}

// Tescilin tipi AIRCRAFTS kaydından. Bulunamazsa null — uydurulmaz.
export function tesciltenTip(reg, ucaklar) {
  const k = tescilAnahtari(reg);
  if (!k) return null;
  const u = (ucaklar || []).find(a => tescilAnahtari(a.registration) === k);
  return tipAnahtari(u?.ac_type) || null;
}

// null → bu kişi bu tipi uçabilir. Değilse ekranda yazılan neden; sıra:
// rol → tip bilinmiyor (kural doğrulanamaz, "uçabilir" denmez) → tip yetkisi.
export function ucusEngeli(profil, acType, tipHaritasi) {
  if (!ucusEkibindenMi(profil)) return 'NOT FLIGHT CREW';
  const tip = tipAnahtari(acType);
  if (!tip) return 'AIRCRAFT TYPE UNKNOWN';
  const yetkiler = (tipHaritasi || {})[profil.id] || [];
  if (!yetkiler.some(t => tipAnahtari(t) === tip)) return `NO ${tip} TYPE RATING`;
  return null;
}

// Görevin uçuş sektörleri için tip yetkisi engelleri, tekrarsız: ["NO GLF4 TYPE RATING — TC-REC", …] (21 Eki 2026, K2).
// 🔑 Serkan: *"tip yetkisi yoksa görev verilemez"* · tescil ASSIGN'da SEKTÖR BAŞINA, zorunlu. Kural `ucusEngeli`nin kendisi
//    (ARCHIVED FLTS ile aynı metin). Tescili seçilmemiş sektör burada sayılmaz — kayıt kapısı "AIRCRAFT" eksik der; DH sayılmaz.
export function tipYetkisiEngelleri(profil, sektorler, ucaklar, tipHaritasi) {
  const out = [];
  for (const s of sektorler || []) {
    if (!s || s.deadhead || !s.reg) continue;
    const e = ucusEngeli(profil, tesciltenTip(s.reg, ucaklar), tipHaritasi);
    const m = e && `${e} — ${String(s.reg).toUpperCase()}`;
    if (m && !out.includes(m)) out.push(m);
  }
  return out;
}
